'use client'
import {initialUserInfoState} from "@/app/userSlice";
import {getTokenExpireTime} from "@/app/utils/auth";
import Util from "@/Master/Util";

export const getUserInfo = async () => {
    if (typeof window === 'undefined'){ // 跳过服务端执行
        return initialUserInfoState;
    }
    const { store } = await import('@/app/store');
    return store.getState().userInfo;
}

export const getRewardType = async () => {
    const {rewardType} = await getUserInfo();
    return rewardType;
}

export const getVipLevel = async () => {
    const {vipLevel} = await getUserInfo();
    return vipLevel;
}

export const getLoginType = async () => {
    const {loginType} = await getUserInfo();
    return loginType;
}

//todo 判断token是否过期
export const hasTokenExpired =  () => {
    let tokenTime = getTokenExpireTime();
    // //默认0就是没有过期
    if (tokenTime <= 0) return false;
    const timeStamp = Util.localTimeStampMill;
    const isExpired = timeStamp >= tokenTime
    if (Util.isLog){
        if (isExpired){
            console.error(`User Slice Token Expired  tokenTime:${tokenTime} token:${Util.localTimeStampMill}`)
        }
    }
    return isExpired;

}